'use es6';

import { getUniqueOnboardingUrl, performOnboardingSetup } from './utils/redirectUtils';
import { mergeQueryParamsToUrl } from './utils/searchUtils';
import { HubletUrl } from './utils/urls';
import { getDecorationParams, maybeGetReplacementRedirectUrl } from './data/redirectData';
import { maybeMapJobFieldToHubInterest } from './utils/surveyMappingUtils';
/**
 * @typedef {import('./index.d.ts').OnboardingOptions} OnboardingOptions - Options for getting onboarding url or performing setup
 */

export const getOnboardingRedirectUrl =
/** @type {OnboardingOptions} */
options => {
  const {
    hublet,
    apiUrl,
    appUrl
  } = options;
  HubletUrl.initializeURLs(hublet, appUrl, apiUrl);
  maybeMapJobFieldToHubInterest(options.survey);
  return getUniqueOnboardingUrl(options);
};
export const setUpOnboardingConfig =
/** @type {OnboardingOptions} */
options => {
  const {
    hublet,
    apiUrl,
    appUrl
  } = options;
  HubletUrl.initializeURLs(hublet, appUrl, apiUrl);
  maybeMapJobFieldToHubInterest(options.survey);
  return performOnboardingSetup(options);
};
export function decorateRedirectUrl({
  url,
  portalId,
  signupType,
  survey = {},
  includeParams = {},
  queryParams = {},
  signupIntent,
  allowUrlReplacement = false,
  hublet,
  appUrl,
  apiUrl,
  shouldNotRedirectToSalesInstallationPage = false
}) {
  HubletUrl.initializeURLs(hublet, appUrl, apiUrl);
  maybeMapJobFieldToHubInterest(survey);
  return mergeQueryParamsToUrl(allowUrlReplacement ? maybeGetReplacementRedirectUrl(url, {
    portalId,
    queryParams,
    signupIntent,
    signupType,
    shouldNotRedirectToSalesInstallationPage
  }) : url, Object.assign({}, includeParams, {}, getDecorationParams({
    intentLink: url,
    signupIntent,
    signupType,
    survey,
    queryParams
  })));
}